import { create } from 'zustand';
import { SearchResult } from '../utils/searchContent';

interface SearchState {
  query: string;
  results: SearchResult[];
  isFocused: boolean;
  setQuery: (query: string) => void;
  setResults: (results: SearchResult[]) => void;
  setFocused: (isFocused: boolean) => void;
  reset: () => void;
}

export const useSearchStore = create<SearchState>((set) => ({
  query: '',
  results: [],
  isFocused: false,
  setQuery: (query) => set({ query }),
  setResults: (results) => set({ results }),
  setFocused: (isFocused) => set({ isFocused }),
  reset: () => set({ query: '', results: [], isFocused: false }),
}));
